(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProfileNotificationController', ProfileNotificationController);

    ProfileNotificationController.$inject = ['$state', 'entity', 'ProfileNotification', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'FirebaseToken'];

    function ProfileNotificationController($state, entity, ProfileNotification, ParseLinks, AlertService, paginationConstants, pagingParams, FirebaseToken) {

        var vm = this;

        vm.profile = entity;
        vm.languages = FirebaseToken.getByProfile({profileId: vm.profile.id});
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicateNotification;
        vm.reverse = pagingParams.ascendingNotification;
        vm.transition = transition;
        vm.itemsPerPage = 50;

        loadAll();

        function loadAll () {
            ProfileNotification.query({
                profileId: vm.profile.id,
                page: pagingParams.pageNotification - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.notifications = data;
                vm.page = pagingParams.pageNotification;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                id: vm.profile.id,
                pageNotification: vm.page,
                sortNotification: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
